import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_API_URL;
const API_URL = `${BACKEND_URL}/tour-reviews`;

const submitTourReview = async (tourBookingId, ratings, comment) => {
  // The backend expects a single rating, so we'll average the ratings
  const averageRating = ratings.reduce((acc, rating) => acc + rating.value, 0) / ratings.length;

  const response = await axios.post(`${API_URL}/add`, {
    tour_booking_id: tourBookingId,
    // The backend model seems to have rating_type_id and rating, but the flutter code sends average rating for both.
    // I will follow the flutter implementation.
    rating_type_id: Math.round(averageRating),
    rating: averageRating,
    comment: comment,
  });
  return response.data;
};

const checkTourReviewExists = async (tourBookingId) => {
    const response = await axios.get(`${API_URL}/check/${tourBookingId}`);
    return response.data.exists;
    };

const tourReviewService = {
  submitTourReview,
  checkTourReviewExists,
};

export default tourReviewService;
